import { CompanyUserCreate } from "@/features/company/pages/CompanyUserCreate";
import { FC } from "react";

const CompanyUserCreatePage: FC = () => {
  return <CompanyUserCreate />;
};

export default CompanyUserCreatePage;
